package cc.easyandroid.easycompose.core.statekeeper

import kotlinx.serialization.DeserializationStrategy
import kotlinx.serialization.SerializationStrategy
import kotlinx.serialization.json.Json

internal val easyComposeJson: Json =
    Json {
        allowStructuredMapKeys = true
    }

internal expect fun <T> T.serialize(strategy: SerializationStrategy<T>): ByteArray

internal expect fun <T> ByteArray.deserialize(strategy: DeserializationStrategy<T>): T
